// Module
var code = "<variant-options\n  variant-id=\"vm.variant.id\"\n  is-vdc=\"vm.article.isVariable && vm.article.productGroup.vdcSupport\"\n  article-node-group=\"vm.nodeGroup\"\n></variant-options>\n";
// Exports
module.exports = code;